// src/componentes/LoginForm.js
import React, { useState } from 'react';
import { Form, Alert } from 'react-bootstrap';
import './Modal.css';

const LoginForm = ({ onLogin, onClose, isSubmitting }) => {
  const [credentials, setCredentials] = useState({
    email: '',
    password: '',
    role: ''
  });
  const [error, setError] = useState('');
  const [touched, setTouched] = useState({
    email: false,
    password: false,
    role: false
  });

  // Función para manejar cambios en los inputs
  const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Validar campos después de interactuar
  const handleBlur = (field) => () => {
    setTouched(prev => ({ ...prev, [field]: true }));
  };

  // Determinar estado de validación
  const getValidationState = (field) => {
    if (!touched[field]) return null;
    return credentials[field] ? 'is-valid' : 'is-invalid';
  };

  // Manejar envío del formulario
  const handleSubmit = async (e) => {
    e.preventDefault();
    setTouched({ email: true, password: true, role: true });
    
    // Validación de rol
    if (!credentials.role) {
      setError('Debe seleccionar un rol para continuar');
      return;
    }
    
    try {
      await onLogin(credentials);
    } catch (error) {
      setError(error.message.replace('Firebase: ', ''));
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      {error && <Alert variant="danger" className="mb-3">{error}</Alert>}

      <Form.Group className="mb-4" controlId="formBasicEmail">
        <Form.Label>Correo electrónico</Form.Label>
        <Form.Control
          type="email"
          placeholder="Ingresa tu email"
          name="email"
          value={credentials.email}
          onChange={handleChange}
          onBlur={handleBlur('email')}
          className={getValidationState('email')}
          required
          disabled={isSubmitting}
        />
      </Form.Group>

      <Form.Group className="mb-4" controlId="formBasicPassword">
        <Form.Label>Contraseña</Form.Label>
        <Form.Control
          type="password"
          placeholder="Contraseña"
          name="password"
          value={credentials.password}
          onChange={handleChange}
          onBlur={handleBlur('password')}
          className={getValidationState('password')}
          required
          disabled={isSubmitting}
        />
      </Form.Group>

      <Form.Group className="mb-4" controlId="formBasicRole">
        <Form.Label>Tipo de usuario *</Form.Label>
        <Form.Select
          name="role"
          value={credentials.role}
          onChange={handleChange}
          onBlur={handleBlur('role')}
          className={getValidationState('role')}
          disabled={isSubmitting}
          required
        >
          <option value="">Seleccione un rol</option>
          <option value="superadmin">Administrador</option>
          <option value="usuario">Usuario</option>
        </Form.Select>
      </Form.Group>

      <div className="modal-footer-buttons">
        <button
          type="button"
          onClick={onClose}
          className="modal-secondary-btn"
          disabled={isSubmitting}
        >
          Cancelar
        </button>
        <button
          type="submit"
          className="modal-primary-btn"
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Verificando...' : 'Iniciar sesión'}
        </button>
      </div>
    </Form>
  );
};

export default LoginForm;